module.exports = __webpack_public_path__ + "img/neutral--pressed.69906bc4.svg";